module.exports = __webpack_public_path__ + "v4assets/hybrid-screenshot.8b7f577dfb7464fb46462fdbf6e994df.png";